import {Checkbox} from 'antd';
import {FormListFieldData} from 'antd/es/form/FormList';
import {StoreValue} from 'antd/es/form/interface';
import cn from 'classnames';
import React, {Dispatch, SetStateAction} from 'react';

import {SimpleActionButton} from 'components/form/components';

import {TTableAttributesCustomSelectEntry} from '../../../report-table-settings';

interface IDDGroupingSettingsModalActionButtonsProps {
  checkedFields: number[];
  attributesEntries: TTableAttributesCustomSelectEntry[];
  fields: FormListFieldData[];
  usingGroup: boolean;
  groupAfterUserFilterValue: boolean;
  add: (defaultValue?: StoreValue, insertIndex?: number) => void;
  remove: (index: number | number[]) => void;
  setCheckedFields: Dispatch<SetStateAction<number[]>>;
  setGroupAfterUserFilterValue: Dispatch<SetStateAction<boolean>>;
  setUsingGroup: Dispatch<SetStateAction<boolean>>;
}

export const DDGroupingSettingsModalFormActionButtons = ({
    checkedFields,
    attributesEntries,
    fields,
    usingGroup,
    groupAfterUserFilterValue,
    add,
    remove,
    setCheckedFields,
    setGroupAfterUserFilterValue,
    setUsingGroup,
}: IDDGroupingSettingsModalActionButtonsProps) => (
    <>
        <div
            className="form-list__header"
            style={{marginBottom: 14}}
        >
            <SimpleActionButton
                type="primary"
                onClick={() => add()}
                icon="PlusCircleOutlined"
                title="Добавить атрибут"
                disabled={!attributesEntries?.length}
            />
            <SimpleActionButton
                type="primary"
                className="button-critic"
                onClick={() => {
                    remove(checkedFields);
                    setCheckedFields([]);
                }}
                disabled={!checkedFields?.length}
                icon="TrashXOutlined"
                title="Удалить выбранное"
            />
            <SimpleActionButton
                type="primary"
                className="remove-all-button"
                onClick={() => {
                    const names = fields?.map(f => f.name);
                    remove(names);
                    setCheckedFields([]);
                }}
                disabled={!fields?.length}
                icon="CloseCircleFilled"
                title="Удалить все"
            />
        </div>
        <div
            className={cn('form-list__row')}
            style={{marginBottom: 7}}
        >
            <Checkbox
                name="groupAfterUserFilter"
                onChange={e => {
                    setGroupAfterUserFilterValue(e?.target?.checked);
                }}
                checked={groupAfterUserFilterValue}
            >
                Группировка после пользовательской фильтрации
            </Checkbox>
        </div>
        <div
            className={cn('form-list__row')}
            style={{marginBottom: 24}}
        >
            <Checkbox
                name="usingGroup"
                onChange={e => {
                    setUsingGroup(e?.target?.checked);
                }}
                checked={usingGroup}
            >
                Применять группировку
            </Checkbox>
        </div>
    </>
);
